<template>
  <div class="header">
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-form class="form" layout="vertical" :model="formState">
          <a-flex wrap="wrap" gap="small" align="flex-end">
            <EntityPicker
              v-model:value="formState.entity"
              default-behavior
              :show-all="false"
              label="Empresa"
              required
            />

            <CampaignPicker
              v-model:value="formState.portfolio"
              default-behavior
              :show-all="false"
              :entity="formState.entity"
              label="Campaña"
              required
            />

            <QueuePicker
              v-model:value="formState.queue"
              default-behavior
              :portfolio="formState.portfolio"
              label="Cola"
            />

            <a-form-item name="date" label="Rango de fecha" required>
              <plan-range-picker
                v-model="formState.date"
                :default-limit="DateRangeLimit"
                :limitValue="DateRangeLimit"
                typeRangeValue="days"
              />
            </a-form-item>
          </a-flex>
        </a-form>
      </a-col>
      <a-col>
        <a-row type="flex">
          <a-button
            type="primary"
            :disabled="isDisabled"
            @click="handleDownload"
            class="button-filter"
          >
            Descargar <DownloadOutlined />
          </a-button>
        </a-row>
      </a-col>
    </a-row>
  </div>

  <section class="info">
    Este reporte solo se podrá descargar al
    <br />
    aplicar los filtros
  </section>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue";
import { DownloadOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

import { ResponseError } from "@/app/shared/utils/httpManager";
import {
  DownloadDto,
  messageTicketsTransferService,
} from "@/app/reports/services/MessageTicketsTransfer.service";

import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import QueuePicker from "@/app/shared/components/pickers/QueuePicker.vue";
// import dayjs from "dayjs";
// import { useDateRangeLimit } from "@/app/shared/composables/useDateRangeLimit";

import PlanRangePicker from "@/app/shared/components/pickers/PlanRangePicker.vue";

const formState: Partial<DownloadDto> = reactive({
  entity: undefined,
  portfolio: undefined,
  queue: undefined,
  date: ["", ""],
});
const DateRangeLimit = 31;
// const { handleCalendarChange, disabledDateRage } = useDateRangeLimit(DateRangeLimit);

const isDisabled = computed(() => {
  let disabled = false;

  if (!formState.date[0] || !formState.date[1]) {
    disabled = true;
  }

  for (const key in formState) {
    const currentValue = formState[key as keyof typeof formState];

    if (currentValue === "" ? false : !currentValue) {
      disabled = true;
      break;
    }
  }

  return disabled;
});

const loading = ref(false);

const handleDownload = async () => {
  loading.value = true;

  try {
    await messageTicketsTransferService.download(formState as DownloadDto);
    // downloadFile(response, "strategies_report.xlsx", { useResponseFileName: true });
    message.success("Se ha encolado la descarga");
  } catch (error) {
    let errorMessage = "Ha ocurrido un error";

    if (error instanceof ResponseError) errorMessage = error.getErrorMessage();

    message.error(errorMessage);
    console.error(error);
  }

  loading.value = false;
};

</script>

<style scoped lang="sass">
.header
  margin-top: 12px

.form
  display: flex
  gap: 8px

  > .ant-form-item
      width: 240px
      margin: 0

.info
  display: grid
  place-content: center
  text-align: center
  color: $gray-7
  font-size: 20px
  font-weight: 400
  margin-top: 150px

.ant-form-item.form-item-picker
  width: 150px

.button-filter
  margin-top: 23px
  margin-left: auto
</style>
